<template>
  <TFormField :has-error="!!error">
    <slot />
    <template #label>
      <slot name="label" />
    </template>
    <template v-if="!!error" #error>
      {{ error }}
    </template>
  </TFormField>
</template>
<script setup lang="ts" generic="T extends GenericObject">
import { type FieldContext, type GenericObject } from 'vee-validate';
import { computed } from 'vue';
import TFormField from './TFormField.vue';
const props = defineProps<{ field: FieldContext }>();
const error = computed(() => props.field.errorMessage.value);
</script>
